// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Button, Card, Col, Input, Row, Select, Switch} from "antd";
import * as OrganizationBackend from "./backend/OrganizationBackend";
import * as UserBackend from "./backend/UserBackend";
import * as GroupBackend from "./backend/GroupBackend";
import * as RoleBackend from "./backend/RoleBackend";
import * as Setting from "./Setting";
import i18next from "i18next";
import PermissionTable from "./table/PermissionTable";

class RoleEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      organizationName: props.organizationName !== undefined ? props.organizationName : props.match.params.organizationName,
      roleName: decodeURIComponent(props.match.params.roleName),
      role: null,
      tempDisplayName: "",
      tempName: "",
      organizations: [],
      users: [],
      groups: [],
      roles: [],
      mode: props.location.mode !== undefined ? props.location.mode : "edit",
      path: sessionStorage.getItem("roleListUrl"),
      showPermission: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.getRole();
    this.getOrganizations();
  }

  getRole() {
    RoleBackend.getRole(this.state.organizationName, this.state.roleName)
      .then((res) => {
        if (res.data === null) {
          this.props.history.push("/404");
          return;
        }
        if (res.status === "error") {
          Setting.showMessage("error", res.msg);
          return;
        }
        let roleData = res.data;
        this.setState({
          tempDisplayName: roleData.displayName,
          tempName: roleData.name,
        }, () => {
          if (this.state.tempDisplayName === "" && this.state.mode === "add") {
            // eslint-disable-next-line no-console
            console.log("roleData", roleData);
            roleData = {
              ...roleData,
              name: "",
              displayName: "",
            };
          }
          if (this.state.path === "/roles-approval" && roleData.rowStatus === 2) {
            this.setState({
              role: roleData.newValue,
            });
          } else {
            this.setState({
              role: roleData,
            });
          }
          this.getGroups(this.state.organizationName);
          this.getRoles(this.state.organizationName);
          this.getUsers(this.state.organizationName);
        });
      });
  }

  getOrganizations() {
    OrganizationBackend.getOrganizations("admin")
      .then((res) => {
        this.setState({
          organizations: res.data || [],
        });
      });
  }

  getUsers(organizationName) {
    UserBackend.getUsers(organizationName)
      .then((res) => {
        if (res.status === "error") {
          Setting.showMessage("error", res.msg);
          return;
        }

        this.setState({
          users: res.data,
        });
      });
  }

  getGroups(organizationName) {
    GroupBackend.getGroups(organizationName)
      .then((res) => {
        if (res.status === "error") {
          Setting.showMessage("error", res.msg);
          return;
        }

        this.setState({
          groups: res.data,
        });
      });
  }

  getRoles(organizationName) {
    RoleBackend.getRoles(organizationName)
      .then((res) => {
        if (res.status === "error") {
          Setting.showMessage("error", res.msg);
          return;
        }

        this.setState({
          roles: res.data,
        });
      });
  }

  parseRoleField(key, value) {
    if ([""].includes(key)) {
      value = Setting.myParseInt(value);
    }
    return value;
  }

  handlePermissionUdate = (data) => {
    this.setState({
      role: {
        ...this.state.role,
        praisindo_permissions: data,
      },
    });
  };

  updateRoleField(key, value) {
    value = this.parseRoleField(key, value);
    const role = this.state.role;
    role[key] = value;
    this.setState({
      role: role,
    });
  }

  updateOrganizationField(key, value) {
    const valueObj = JSON.parse(value);
    if (valueObj.permission) {
      this.setState({
        showPermission: false,
      });
    } else {
      this.setState({
        showPermission: true,
      });
    }

    const role = this.state.role;
    role[key] = valueObj.name;
    this.setState({
      role: role,
    });
  }

  renderAction = (rowStatus) => {
    const {path} = this.state;

    if (path === "/roles") {
      if (rowStatus === 0 && this.state.tempDisplayName === "") {
        return (
          <>
            <Button size="large" onClick={() => this.submitRoleEdit(false)}>{i18next.t("general:Save")}</Button>
            <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitRoleEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
            <Button style={{marginLeft: "20px"}} onClick={() => this.deleteRole()}>{i18next.t("general:Cancel")}</Button>
          </>
        );
      } else if (rowStatus === 1) {
        return (
          <>
            <Button size="large" onClick={() => this.submitRoleEdit(false)}>{i18next.t("general:Save")}</Button>
            <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitRoleEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
          </>
        );
      } else {
        return (
          <>
            <Button disabled style={{marginLeft: "20px", backgroundColor: "rgba(0, 0, 0, 0.04)"}} type="primary" onClick={() => this.approveRole()}>{i18next.t("general:Approve")}</Button>
            <Button disabled style={{marginLeft: "20px"}} danger type="primary" onClick={() => this.rejectRole()}>{i18next.t("general:Reject")}</Button>
            <Button style={{marginLeft: "20px", border: "1px solid red", backgroundColor: "transparent", color: "red"}} type="primary" onClick={() => this.props.history.push(path)}>{i18next.t("general:Cancel")}</Button>
          </>
        );
      }
    } else if (path === "/roles-approval") {
      return (
        <>
          <Button style={{marginLeft: "20px", backgroundColor: "green"}} type="primary" onClick={() => this.approveRole()}>{i18next.t("general:Approve")}</Button>
          <Button style={{marginLeft: "20px"}} danger type="primary" onClick={() => this.rejectRole()}>{i18next.t("general:Reject")}</Button>
          <Button style={{marginLeft: "20px", border: "1px solid red", backgroundColor: "transparent", color: "red"}} type="primary" onClick={() => this.props.history.push(path)}>{i18next.t("general:Cancel")}</Button>
        </>
      );
    }

    // Default action if no condition is met
    return (
      <>
        <Button size="large" onClick={() => this.submitRoleEdit(false)}>{i18next.t("general:Save")}</Button>
        <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitRoleEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
      </>
    );
  };

  renderRole() {
    let readOnly = false;
    if (this.state.path === "/roles-approval") {
      readOnly = true;
    }

    if (this.state.path === "/roles") {
      if (this.state.role.rowStatus !== 1) {
        readOnly = true;
      }
      if (this.state.role.rowStatus === 0 && this.state.tempDisplayName === "") {
        readOnly = false;
      }
    }

    const isApproveMode = this.state.mode === "approve";
    const isDisabled = isApproveMode || readOnly;
    return (
      <Card size="small" title={
        <div>
          {this.renderAction(this.state.role.rowStatus)}
        </div>

      } style={(Setting.isMobile()) ? {margin: "5px"} : {}} type="inner">
        <Row style={{marginTop: "10px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Organization"), i18next.t("general:Organization - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Select virtual={false} style={{width: "100%"}} disabled={!Setting.isAdminUser(this.props.account) || isDisabled} value={this.state.role.owner} onChange={(value => {this.updateOrganizationField("owner", value);})}
              options={this.state.organizations.map((organization) => Setting.getOption(organization.name, JSON.stringify({name: organization.name, permission: organization.permission})))
              } />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Name"), i18next.t("general:Name - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input disabled={isDisabled} value={this.state.role.name} onChange={e => {
              this.updateRoleField("name", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Display name"), i18next.t("general:Display name - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input disabled={isDisabled} value={this.state.role.displayName} onChange={e => {
              this.updateRoleField("displayName", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Description"), i18next.t("general:Description - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input disabled={isDisabled} value={this.state.role.description} onChange={e => {
              this.updateRoleField("description", e.target.value);
            }} />
          </Col>
        </Row>
        {
          !Setting.hideFieldEditRoles &&
          <>
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
                {Setting.getLabel(i18next.t("role:Sub users"), i18next.t("role:Sub users - Tooltip"))} :
              </Col>
              <Col span={22} >
                <Select virtual={false} mode="multiple" style={{width: "100%"}} disabled={isDisabled} value={this.state.role.users}
                  onChange={(value => {this.updateRoleField("users", value);})}
                  options={this.state.users.map((user) => Setting.getOption(`${user.owner}/${user.name}`, `${user.owner}/${user.name}`))}
                />
              </Col>
            </Row>
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
                {Setting.getLabel(i18next.t("role:Sub groups"), i18next.t("role:Sub groups - Tooltip"))} :
              </Col>
              <Col span={22} >
                <Select virtual={false} mode="multiple" style={{width: "100%"}} disabled={isDisabled} value={this.state.role.groups}
                  onChange={(value => {this.updateRoleField("groups", value);})}
                  options={this.state.groups.map((group) => Setting.getOption(`${group.owner}/${group.name}`, `${group.owner}/${group.name}`))}
                />
              </Col>
            </Row>
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
                {Setting.getLabel(i18next.t("role:Sub roles"), i18next.t("role:Sub roles - Tooltip"))} :
              </Col>
              <Col span={22} >
                <Select virtual={false} mode="multiple" style={{width: "100%"}} disabled={isDisabled} value={this.state.role.roles} onChange={(value => {this.updateRoleField("roles", value);})}
                  options={this.state.roles.filter(role => (role.owner !== this.state.role.owner || role.name !== this.state.role.name)).map((role) => Setting.getOption(`${role.owner}/${role.name}`, `${role.owner}/${role.name}`))
                  } />
              </Col>
            </Row>
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
                {Setting.getLabel(i18next.t("role:Sub domains"), i18next.t("role:Sub domains - Tooltip"))} :
              </Col>
              <Col span={22} >
                <Select virtual={false} mode="tags" style={{width: "100%"}} disabled={isDisabled} value={this.state.role.domains} onChange={(value => {
                  this.updateRoleField("domains", value);
                })}
                options={this.state.role.domains?.map((domain) => Setting.getOption(domain, domain))
                } />
              </Col>
            </Row>
          </>
        }
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 19 : 2}>
            {Setting.getLabel(i18next.t("general:Is enabled"), i18next.t("general:Is enabled - Tooltip"))} :
          </Col>
          <Col span={1} >
            <Switch disabled={isDisabled} checked={this.state.role.isEnabled} onChange={checked => {
              this.updateRoleField("isEnabled", checked);
            }} />
          </Col>
        </Row>
        {
          !this.state.showPermission && this.state.role.praisindo_permissions &&
          <Row style={{marginTop: "20px"}} >
            <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
              {Setting.getLabel(i18next.t("adapter:Permission"), i18next.t("adapter:Permission - Tooltip"))} :
            </Col>
            <Col span={22}>
              <PermissionTable onDataUpdate={(e) => this.handlePermissionUdate(e)} isDisabled={isDisabled} listData={this.state.role.praisindo_permissions || []} />
            </Col>
          </Row>
        }
      </Card>
    );
  }

  submitRoleEdit(exitAfterSave) {
    const role = Setting.deepCopy(this.state.role);
    if (!this.isSubmitUserValidate()) {
      RoleBackend.updateRole(this.state.organizationName, this.state.roleName, role)
        .then((res) => {
          if (res.status === "ok") {
            Setting.showMessage("success", i18next.t("general:Successfully saved"));
            this.setState({
              roleName: this.state.role.name,
              tempDisplayName: this.state.role.displayName,
            });

            if (exitAfterSave) {
              this.props.history.push("/roles");
            } else {
              this.props.history.push(`/roles/${this.state.role.owner}/${encodeURIComponent(this.state.role.name)}`);
            }
          } else {
            Setting.showMessage("error", `${i18next.t("general:Failed to save")}: ${res.msg}`);
          }
        })
        .catch(error => {
          Setting.showMessage("error", `${i18next.t("general:Failed to connect to server")}: ${error}`);
        });
    }
  }

  deleteRole() {
    RoleBackend.deleteRole(this.roleDeleted())
      .then((res) => {
        if (res.status === "ok") {
          this.props.history.push("/roles");
        } else {
          Setting.showMessage("error", `${i18next.t("general:Failed to delete")}: ${res.msg}`);
        }
      })
      .catch(error => {
        Setting.showMessage("error", `${i18next.t("general:Failed to connect to server")}: ${error}`);
      });
  }

  roleDeleted() {
    return {
      "name": this.state.tempName,
      "owner": this.state.role.owner,
    };
  }

  rejectRole() {
    RoleBackend.rejectRole(this.roleDeleted())
      .then((res) => {
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully reject"));
          this.props.history.push("/roles-approval");
        } else {
          Setting.showMessage("error", `${i18next.t("general:Failed to reject")}: ${res.msg}`);
        }
      })
      .catch(error => {
        Setting.showMessage("error", `${i18next.t("general:Failed to connect to server")}: ${error}`);
      });
  }

  approveRole() {
    RoleBackend.approveRole(this.roleDeleted())
      .then((res) => {
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("general:Successfully approve"));
          this.props.history.push("/roles-approval");
        } else {
          Setting.showMessage("error", `${i18next.t("general:Failed to approve")}: ${res.msg}`);
        }
      })
      .catch(error => {
        Setting.showMessage("error", `${i18next.t("general:Failed to connect to server")}: ${error}`);
      });
  }

  isSubmitUserValidate = () => {
    const {role} = this.state;
    switch (true) {
    case role?.name === "":
      Setting.showMessage("error", `${i18next.t("general:Name can not be empty")}`);
      return true;
    case role?.displayName === "":
      Setting.showMessage("error", `${i18next.t("general:Display name can not be empty")}`);
      return true;
    default:
      return false;
    }
  };

  render() {
    return (
      <div>
        {
          this.state.role !== null ? this.renderRole() : null
        }
        <div style={{marginTop: "20px", marginLeft: "40px"}}>
          {this.renderAction(this.state.role?.rowStatus)}
        </div>
      </div>
    );
  }
}

export default RoleEditPage;
